import { commonFilter } from './filter';

export default {
  pageName: 'Topic Tracking - Overview Table',
  pageId: '20109',
  pagePath: '/opinion/Summary/TopicTracking',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    STO_sentiment: {
      buttonId: '201090',
    },
    STO_index: {
      buttonId: '201091',
    },
    KONO_ClickTopic: {
      buttonId: '201092',
    },
    STO_topicPosition: {
      buttonId: '201093',
    },
    STO_topicPositionSetting: {
      buttonId: '201094',
    },
    STO_tier2TopicCard: {
      buttonId: '201095',
    },
    STO_detailsToFeeds: {
      buttonId: '201096',
    },
    STO_toFeeds: {
      buttonId: '201097',
    },
    STO_tierTopic: {
      buttonId: '2010920',
    },
    STO_AllKeyTAB: {
      buttonId: '2010910',
    },
    STO_Trans: {
      buttonId: '2010911',
    },
    STO_ListRank: {
      buttonId: '2010912',
    },
    TAB_AnalysisTAB: {
      buttonId: '2010914',
    },
    STO_TopicGoFeeds: {
      buttonId: '2010915',
    },
    STO_TopicOpenList: {
      buttonId: '2010916',
    },
    STO_tier2TopicOpenList: {
      buttonId: '2010917',
    },
    STO_definition: {
      buttonId: '2010918',
    },
    GPT_Get_Btn: {
      buttonId: '2010913',
    },
    GPT_Confirm: {
      buttonId: '2010921',
    },
    ...commonFilter,
  },
  card: {
    TopicPerformance: {
      table: {
        buttonId: '2010919',
      },
      line: {
        buttonId: '2010920',
      },
    },
  },
};
